import { useState } from 'react';
import { useClients } from '@/features/clients/hooks/useClients';
import { Search, UserCircle } from 'lucide-react';
import type { WizardState } from '../../hooks/useSessionWizard';

interface Props {
  wizard: {
    state: WizardState;
    selectClient: (clientId: string) => void;
  };
}

export default function Step1Client({ wizard }: Props) {
  const { clients = [] } = useClients();
  const [search, setSearch] = useState('');

  const filtered = clients.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold font-display mb-1">Sélectionner un client</h2>
        <p className="text-sm text-muted-foreground">Choisissez le client pour cette session</p>
      </div>

      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Rechercher un client…"
          className="w-full pl-9 pr-4 py-3 bg-background border-2 border-border rounded-xl focus:border-primary focus:outline-none transition-colors"
        />
      </div>

      {filtered.length === 0 ? (
        <div className="glass-card p-8 text-center">
          <UserCircle className="mx-auto text-muted-foreground mb-2" size={32} />
          <p className="text-sm text-muted-foreground">Aucun client trouvé</p>
        </div>
      ) : (
        <ul className="space-y-2 max-h-96 overflow-y-auto">
          {filtered.map((client) => (
            <li key={client.id}>
              <button
                onClick={() => wizard.selectClient(client.id)}
                className="w-full text-left glass-card p-4 hover:border-primary hover:bg-primary/5 transition-all duration-200 flex items-center gap-3"
              >
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-sm shrink-0">
                  {client.name.charAt(0).toUpperCase()}
                </div>
                <div className="min-w-0">
                  <p className="font-semibold text-sm">{client.name}</p>
                  {client.phone && (
                    <p className="text-xs text-muted-foreground">{client.phone}</p>
                  )}
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
